export default __webpack_public_path__ + "static/lframe-compare-loans-71dee3a65a63c1750f1747c3675f12f6.png";